"use client"

import { Marquee } from "@shared/ui/landing/marquee"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { ENTERPRISE_LOGOS } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function EnterpriseSection() {
  const t = useTranslations("enterprise")

  const items = ENTERPRISE_LOGOS.map((name) => (
    <div
      key={name}
      className="flex h-16 min-w-[180px] items-center justify-center rounded-xl border border-white/10 bg-white/5 px-6 grayscale transition hover:grayscale-0"
    >
      <span className="text-sm font-semibold tracking-wide text-white/70">{name}</span>
    </div>
  ))

  return (
    <SectionContainer>
      <div className="mb-8 space-y-3 text-center">
        <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t("title")}</h2>
        <p className="text-muted-foreground">{t("subtitle")}</p>
      </div>
      <Marquee items={items} speed={40} className="py-2" />
    </SectionContainer>
  )
}
